import { Controller } from "@hotwired/stimulus"

/**
 * Use on links that should trigger a save of all voting forms (two-sided, statement, pie)
 * before navigating. Dispatches saveBeforeNavigate; voting controllers push their save
 * promises to event.detail.promises; we wait for them (with timeout) then navigate.
 */
export default class extends Controller<HTMLAnchorElement> {
  static values = {
    timeout: { type: Number, default: 3000 },
  }

  declare timeoutValue: number

  navigate(event: Event) {
    const href = this.element.getAttribute("href")
    if (!href) return

    event.preventDefault()

    const go = () => {
      window.location.href = href
    }

    const detail = { promises: [] as Promise<unknown>[] }
    document.dispatchEvent(new CustomEvent("saveBeforeNavigate", { detail, bubbles: true }))

    const allSaves = detail.promises.length ? Promise.all(detail.promises) : Promise.resolve()
    const timeoutPromise = new Promise<void>((resolve) => setTimeout(resolve, this.timeoutValue))
    Promise.race([allSaves, timeoutPromise])
      .then(() => go())
      .catch(() => go())
  }
}
